module.exports = __webpack_public_path__ + "img/game_calendar.2144b460.png";